import { Theme } from "@npco/zeller-design-system";
import * as Sentry from "@sentry/browser";
import * as Core from "@zeller-public/payments-sdk-core";

import { onCancel } from "./on-cancel";
import { logger } from "./shared/logger";
import { tags, tags_fromRequest } from "./tags";

export function onRequestQuery(request: Core.Protocol.Request_Query) {
	if (window._request) {
		logger.warn("request: ignored busy");
		return;
	}

	Sentry.getIsolationScope().clear();

	tags(tags_fromRequest(request));

	if ("theme" in request.query) {
		if (request.query.theme === "system") {
			Theme.set(undefined);
		} else {
			Theme.set(request.query.theme);
		}
	}

	onCancel(undefined); // Use default handler.

	logger.info("request: initiated", { type: request.query.$type });

	// Update React render state to begin flow.
	window._request = request;
	window._setRequest?.(request);
}
